import React from "react";
import { Wrapper } from "./styled";

const DoubleLine = () => {
  return <Wrapper>o</Wrapper>;
};

export default DoubleLine;
